import { Model } from "@binale-tech/shared";

/**
 * Virtual quarter periods (Quartal 1-4) used by period selectors alongside Model.Period.
 * They are UI/filter-level values only and must never be persisted on a record
 * or written into the global YearPeriodContext.
 */
export type QuarterPeriod = 41 | 42 | 43 | 44;

export const quarterPeriods: QuarterPeriod[] = [41, 42, 43, 44];

export const isQuarterPeriod = (period: number): period is QuarterPeriod =>
    quarterPeriods.includes(period as QuarterPeriod);

export const getQuarterPeriods = (quarter: QuarterPeriod): Model.Period[] => {
    const firstMonth = (quarter - 41) * 3 + 1;
    const monthPeriods = [firstMonth, firstMonth + 1, firstMonth + 2] as Model.Period[];
    if (quarter === 41) {
        return [Model.Period.FirstDayOfYear, ...monthPeriods];
    }
    if (quarter === 44) {
        return [...monthPeriods, Model.Period.LastDayOfYear];
    }
    return monthPeriods;
};
